import { Component, OnInit } from '@angular/core';
import { DialogService } from '../../../../services/dialog/dialog.service';
import { UnsubscribeOnDestroyAdapter } from '../../../adapters/unsubscibe-on-destroy.adapter';

@Component({
  selector: 'psc-info-dialog',
  templateUrl: './info-dialog.component.html',
})
export class InfoDialogComponent extends UnsubscribeOnDestroyAdapter implements OnInit {

  infoText: string | undefined;
  showInfoDialog: boolean;


  constructor(
    private dialogService: DialogService,
  ) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.dialogService.infoDialogObservable$.subscribe((info) => {
      this.infoText = info;
      this.showInfoDialog = true;
    });
  }
}
